import React, { PureComponent } from 'react';
import { Grid, Box, Typography } from '@material-ui/core';
import { IMG_ONBOARDING } from 'images';
import './onboarding.scss';

class OnboardingStepTemplate extends PureComponent {
  render() {
    const { children, step } = this.props;
    return (
      <div className="onboarding">
        <img src={IMG_ONBOARDING} alt="" className="onboarding-hero-top" />
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Box paddingLeft="135px" paddingTop="25px">
              <Grid item xs={6} className="onboarding-steps">
                <Typography
                  className={`onboarding-step ${
                    step === '1' ? 'selected-step' : ''
                  }`}
                >
                  01
                </Typography>
                <Typography
                  className={`onboarding-step ${
                    step === '2' ? 'selected-step' : ''
                  }`}
                >
                  02
                </Typography>
                <Typography
                  className={`onboarding-step ${
                    step === '3' ? 'selected-step' : ''
                  }`}
                >
                  03
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {children}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default OnboardingStepTemplate;
